<template>
  <!-- Breadcrumbs -->
  <BaseContainer class="md:hidden">
    <V3Breadcrumbs
      :breadcrumb-items="[
        { type: 'link', text: $t('terms.home'), to: '/' } as const
      ]"
      :current-page-text="current?.title || ''"
    />
  </BaseContainer>

  <!-- Banner -->
  <header class="relative">
    <img
      alt="banner-faqs"
      src="/images/banner-faqs.jpg"
      class="hidden md:block w-full h-full object-cover object-center"
    />
    <img
      alt="banner-faqs"
      src="/images/banner-faqs.jpg"
      class="md:hidden w-full h-full object-cover object-center"
    />
    <BaseContainer>
      <h1
        class="hidden md:block absolute top-1/2 -translate-y-1/2 text-[32px] font-bold text-black z-10"
      >
        {{ current?.title }}
      </h1>
    </BaseContainer>

    <div class="md:hidden px-4">
      <TopbarPrivacyNavigation :title="current?.title" />
    </div>
  </header>

  <BaseContainer>
    <div class="flex my-6 md:my-14 gap-x-[122px]">
      <aside
        :class="
          twJoin(
            'hidden md:block w-full md:w-auto',
            width < 768 && !path && '!block'
          )
        "
      >
        <ClientOnly>
          <NuxtLinkLocale
            v-for="(item, index) in navigation"
            :key="index"
            :to="item.path"
            :class="
              twJoin(
                'flex justify-between items-center md:block py-4 first:pt-0 [&:not(:last-child)]:border-b border-dashed border-border-divider md:w-[332px] font-bold',
                includes(path, item.path) && 'text-primary-tangerine'
              )
            "
          >
            <div>
              {{ item.title }}
            </div>
            <div class="md:hidden">
              <Icon name="chevron-right" />
            </div>
          </NuxtLinkLocale>
        </ClientOnly>
      </aside>

      <main
        v-if="currentContent"
        class="bg-gray-0 px-4 md:px-[80px] py-10 rounded-2xl"
      >
        <SunEditorRenderer
          :value="currentContent[locale as keyof typeof currentContent]"
        />
      </main>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
import { includes, find } from 'lodash-es'
import { twJoin } from 'tailwind-merge'

import termsAndConditionsEn from '~/assets/content/terms/termsAndConditionsEn'
import termsAndConditionsTh from '~/assets/content/terms/termsAndConditionsTh'

import personalDataConsentEn from '~/assets/content/terms/personalDataConsentEn'
import personalDataConsentTh from '~/assets/content/terms/personalDataConsentTh'

import privacyPolicyTh from '~/assets/content/terms/privacyPolicyTh'
import privacyPolicyEn from '~/assets/content/terms/privacyPolicyEn'

const { t, locale } = useI18n()
const { width } = useWindowSize()

const route = useRoute()
const path = computed(() => route.path)

// 🔥 Import Braze tracking
const { trackStaticPageView } = useCaseClubEvents()

const navigation = [
  {
    path: '/terms-and-conditions',
    title: t('terms.termsAndConditions'),
    content: {
      th: termsAndConditionsTh,
      en: termsAndConditionsEn
    }
  },
  {
    path: '/personal-data-consent',
    title: t('terms.personalDataConsent'),
    content: {
      th: personalDataConsentTh,
      en: personalDataConsentEn
    }
  },
  {
    path: '/privacy-policy',
    title: t('terms.privacyPolicy'),
    content: {
      th: privacyPolicyTh,
      en: privacyPolicyEn
    }
  }
]

const current = computed(() =>
  find(navigation, (item) => includes(path.value, item.path))
)

const currentContent = computed(() => current.value?.content)

// 🔥 Track static page view on mount
onMounted(() => {
  try {
    trackStaticPageView({
      page_slug: 'privacy-policy',
      page_name: 'Privacy Policy',
      url: window.location.href
    })
  } catch (error) {
  }
})

// Meta
useSeoMeta({
  title: () => t('pages.privacyPolicy.meta.title'),
  description: () => t('pages.privacyPolicy.meta.description')
})
</script>
